import React, { useState, useRef } from 'react';
import Webcam from 'react-webcam';
import iconCameraRed from '../assets/icon/icon_camera_red.svg';

const PhotoUploader = ({ onPhotoSelect, onClose, mode }) => {
  const [file, setFile] = useState(null);
  const [cameraActive, setCameraActive] = useState(true);
  const webcamRef = useRef(null);

  // Set options for the Webcam component
  const videoConstraints = {
    width: { min: 720 },
    height: { min: 480 },
    aspectRatio: 16 / 9,
    facingMode: 'environment' // 'user' for front camera, 'environment' for back camera
  };

  // Function to capture a photo from webcam
  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setFile(imageSrc); // Display the captured image
    const imageBlob = dataURLtoBlob(imageSrc);
    onPhotoSelect(imageBlob); // Send the Blob image to the parent component
  };

  // Function to convert data URL to Blob
  const dataURLtoBlob = (dataURL) => {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(URL.createObjectURL(selectedFile));
      onPhotoSelect(selectedFile);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      {mode === 'camera' && (
        <>
          {' '}
          <Webcam
            audio={false}
            height={480}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width={720}
            videoConstraints={videoConstraints}
            screenshotQuality={1}
            imageSmoothing={true}
            mirrored={false}
            className="bg-black h-[480px] w-[720px] aspect-auto"
          />
          <button
            onClick={capturePhoto}
            className="h-[100px] w-[100px] mt-2 flex justify-center items-center">
            <img src={iconCameraRed} alt="w-full h-full object-contain" />
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-2 rounded mt-2">
            Batal
          </button>
        </>
      )}

      {mode === 'upload_file' && (
        <>
          {' '}
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="border p-2"
          />
          {file && <img src={file} alt="Selected" className="max-w-xs mt-4" />}
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-2 rounded mt-2">
            Batal
          </button>
        </>
      )}
    </div>
  );
};

export default PhotoUploader;
